import React, { useState } from "react";
import "../styles/EditEntryForm.css";
import AutofillAIForm from "./AutofillAIForm.js";

// Input: An existing resource doccument
// Output: a modifed version of that resouce doccument
// Error:
const EditEntryForm = ({ entry, onSave, onCancel }) => {
	const countyOptions = [
		"",
		"Alachua",
		"Baker",
		"Bay",
		"Bradford",
		"Broward",
		"Calhoun",
		"Cirtus",
		"Clay",
		"Collier",
		"Dixie",
		"Duval",
		"Flagler",
		"Franklin",
		"Gadsden",
		"Gilchrist",
		"Glades",
		"Gulf",
		"Hamilton",
		"Hardee",
		"Hendry",
		"Hernando",
		"Highlands",
		"Hillsborough",
		"Indian River",
		"Jackson",
		"Jefferson",
		"Lake",
		"Lafayette",
		"Lee",
		"Leon",
		"Levy",
		"Liberty",
		"Madison",
		"Manatee",
		"Marion",
		"Martin",
		"Miami-Dade",
		"Monroe",
		"Nassau",
		"Okaloosa",
		"Okeechobee",
		"Orange",
		"Osceola",
		"Palm Beach",
		"Pasco",
		"Pinellas",
		"Polk",
		"Putnam",
		"Santa Rosa",
		"Sarasota",
		"Seminole",
		"St. Johns",
		"St. Lucie",
		"Sumter",
		"Suwannee",
		"Taylor",
		"Union",
		"Volusia",
		"Wakulla",
		"Walton",
		"Statewide & National",
		"Central Florida (Osceola, Highlands, Hardee, Polk, Seminole, Orange, Lake, Sumter, Marion)",
	];

	const categoryOptions = [
			"",
		"Affordable Housing",
		"Air Conditioning/Heating",
		"Camps & After School Programs",
		"Case Management",
		"Case Managers",
		"Chronic Conditions / Disabilities",
		"Discounted Goods",
		"Early Childhood Learning",
		"Financial Aid / Discounts",
		"Financial Assistance",
		"Find a Job",
		"Find a Provider",
		"Food for Families of Hospitalized Patients",
		"Food for Seniors",
		"Food Pantries",
		"Foreclosure / Eviction Prevention",
		"Formula",
		"Free Legal Assistance",
		"Government Benefits",
		"Guardianship",
		"Help with Legal Fees",
		"Help with Utilities",
		"Home Maintenance",
		"Homeless Services",
		"Hot Meals / Daily Meals",
		"Immigration Services",
		"Insurance Assistance",
		"Internet & Phone",
		"Job Skills Training",
		"Meals for K-12",
		"Medicaid / Insurance",
		"Medical Equipment (DME)",
		"Medical Flights",
		"Medical Transport",
		"Mental Health",
		"Mold & Pests",
		"Mortgage Assistance",
		"Nutrition Education",
		"Other Help",
		"Paratransit/Door-to-door Transit",
		"Prescription Costs",
		"Rental Assistance",
		"Scholarships",
		"Shelters / Temporary Housing",
		"SNAP/Food Stamps/WIC",
		"Support Children with Disabilities",
		"Therapy",
	];

	const [dropdownOpen, setDropdownOpen] = useState(false);
	const [countyDropdownOpen, setCountyDropdownOpen] = useState(false);

	// Separates categories if there are any
	const parsedCategories = entry.Category
		? entry.Category.split(/[,;]+/)
				.map((cat) => cat.trim())
				.filter((cat) => categoryOptions.includes(cat))
		: [];

	const parsedCounties = entry.County
		? entry.County.split(/[,]+/)
				.map((county) => county.trim())
				.filter((county) => countyOptions.includes(county))
		: [];

	const parsedPhones = entry.Phone ? (Array.isArray(entry.Phone) ? entry.Phone : entry.Phone.split(/[,]+/).map((phone) => phone.trim())) : [];

	const parsedEmails = entry.Email ? (Array.isArray(entry.Email) ? entry.Email : entry.Email.split(/[,]+/).map((email) => email.trim())) : [];

	//Sets up form data with exisitng information
	const [formData, setFormData] = useState({
		...entry,
		Category: parsedCategories,
		County: parsedCounties,
		Phone: parsedPhones,
		Email: parsedEmails,
	});

	const [selectedAddressIndex, setSelectedAddressIndex] = useState(0);
	const [selectedPhoneIndex, setSelectedPhoneIndex] = useState(0);
	const [selectedEmailIndex, setSelectedEmailIndex] = useState(0);

	// updates from data with form changes, and changes textarea to fit
	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });

		// Dynamically adjust textarea height
		if (e.target.tagName === "TEXTAREA") {
			e.target.style.height = "auto"; // Reset height
			e.target.style.height = `${e.target.scrollHeight}px`; // Set height based on content
		}
	};

	const [isModalOpen, setIsModalOpen] = useState(false);
	const openModal = () => setIsModalOpen(true);
	const closeModal = () => setIsModalOpen(false);

	const handleAutofill = (aiData) => {
		console.log("AI Data received:", aiData);

		setFormData({
			Name: aiData.Name || "N/A",
			County: aiData.County || "N/A",
			Zip_Codes: aiData.Zip_Codes || [],
			Category: aiData.Category
				? aiData.Category.split(",")
						.map((cat) => cat.trim())
						.filter((cat) => categoryOptions.includes(cat))
				: [],
			Services: aiData.Services || "N/A",
			Eligibility_Requirement: aiData.Eligibility_Requirement || "N/A",
			How_To_Apply: aiData.How_To_Apply || "N/A",
			Phone: aiData.Phone || [],
			Email: aiData.Email || [],
			Website: aiData.Website || "N/A",
			Address: aiData.Address || [],
			Search_Term: aiData.Search_Term || "N/A",
			_id: entry._id,
		});
		closeModal();
	};

	const handleAddressChange = (value) => {
		const updatedAddresses = [...formData.Address];
		updatedAddresses[selectedAddressIndex] = value;
		setFormData({ ...formData, Address: updatedAddresses });
	};

	const handleAddAddress = () => {
		const updatedAddresses = [...(formData.Address || []), ""];
		setFormData({ ...formData, Address: updatedAddresses });
		setSelectedAddressIndex(updatedAddresses.length - 1); // Select the new address
	};

	const handleDeleteAddress = () => {
		const updatedAddresses = formData.Address.filter((_, i) => i !== selectedAddressIndex);
		setFormData({ ...formData, Address: updatedAddresses });
		setSelectedAddressIndex(0); // Reset to the first address if available
	};

	const handlePhoneChange = (value) => {
		const updatedPhones = [...(formData.Phone || [])];
		updatedPhones[selectedPhoneIndex] = value;
		setFormData({ ...formData, Phone: updatedPhones });
	};

	// Adds a new address from the form
	const handleAddPhone = () => {
		const updatedPhones = [...(formData.Phone || []), ""];
		setFormData({ ...formData, Phone: updatedPhones });
		setSelectedPhoneIndex(updatedPhones.length - 1); //select the new address
	};

	// Removes and address from the form
	const handleDeletePhone = () => {
		const updatedPhones = formData.Phone.filter((_, i) => i !== selectedPhoneIndex);
		setFormData({ ...formData, Phone: updatedPhones });
		setSelectedPhoneIndex(0); //reset to the first address if available
	};

	const handleEmailChange = (value) => {
		const updatedEmails = [...(formData.Email || [])];
		updatedEmails[selectedEmailIndex] = value;
		setFormData({ ...formData, Email: updatedEmails });
	};

	// Adds a new address from the form
	const handleAddEmail = () => {
		const updatedEmails = [...(formData.Email || []), ""];
		setFormData({ ...formData, Email: updatedEmails });
		setSelectedEmailIndex(updatedEmails.length - 1); //select the new address
	};

	// Removes and address from the form
	const handleDeleteEmail = () => {
		const updatedEmails = formData.Email.filter((_, i) => i !== selectedEmailIndex);
		setFormData({ ...formData, Email: updatedEmails });
		setSelectedEmailIndex(0); //reset to the first address if available
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		const updatedFormData = {
			...formData,
			Category: formData.Category.join(", "), // Convert array to string
			County: formData.County.join(", "),
		};

		onSave(updatedFormData); // Save the updated data
	};

	return (
		<div className="EditEntryForm">
			<h3>Edit Entry</h3>
			<form onSubmit={handleSubmit}>
				<label>
					Date Last Updated:
					<span> {formData.Date_Uploaded || "Upload Date Missing"}</span>
				</label>
				<div className="UserDetails">
					<label>
						Resource Center Name:
						<textarea type="text" name="Name" value={formData.Name} onChange={handleChange} placeholder="Enter resource center name" />
					</label>

					{/* <label>
						Counties Served:
						<textarea type="text" name="County" value={formData.County} onChange={handleChange} placeholder="Enter county" />
					</label> */}

					<label>
						Counties Served:
						<div className="category-dropdown">
							<div className="dropdown-label" onClick={() => setCountyDropdownOpen(!countyDropdownOpen)}>
								Select Counties ▼
							</div>
							{countyDropdownOpen && (
								<div className="dropdown-options">
									{countyOptions.map((county, index) => (
										<label key={index}>
											<input
												type="checkbox"
												checked={formData.County.includes(county)}
												onChange={() => {
													setFormData((prevData) => {
														const updatedCounties = prevData.County.includes(county)
															? prevData.County.filter((c) => c !== county)
															: [...prevData.County, county];
														return { ...prevData, County: updatedCounties };
													});
												}}
											/>
											<span>{county}</span>
										</label>
									))}
								</div>
							)}
						</div>
					</label>

					<label>
						Zip Codes:
						<textarea type="text" name="Zip_Codes" value={formData.Zip_Codes} onChange={handleChange} placeholder="Enter zip code(s)" />
					</label>

					<label>
						Categories
						<div className="category-dropdown">
							<div className="dropdown-label" onClick={() => setDropdownOpen(!dropdownOpen)}>
								Select Categories ▼
							</div>
							{dropdownOpen && (
								<div className="dropdown-options">
									{categoryOptions.map((category, index) => (
										<label key={index}>
											<input
												type="checkbox"
												checked={formData.Category.includes(category)}
												onChange={() => {
													setFormData((prevData) => {
														const updatedCategories = prevData.Category.includes(category)
															? prevData.Category.filter((c) => c !== category)
															: [...prevData.Category, category];
														return { ...prevData, Category: updatedCategories };
													});
												}}
											/>
											<span>{category}</span>
										</label>
									))}
								</div>
							)}
						</div>
					</label>

					<label>
						Services:
						<textarea type="text" name="Services" value={formData.Services} onChange={handleChange} placeholder="Enter services provided" />
					</label>
					<label>
						Eligibility Requirements:
						<textarea
							type="text"
							name="Eligibility_Requirement"
							value={formData.Eligibility_Requirement}
							onChange={handleChange}
							placeholder="Enter eligibility requirements"
						/>
					</label>
					<label>
						How To Apply:
						<textarea type="text" name="How_To_Apply" value={formData.How_To_Apply} onChange={handleChange} placeholder="Enter application process" />
					</label>
					<label>
						Search Terms:
						<textarea type="text" name="Search_Term" value={formData.Search_Term} onChange={handleChange} placeholder="Enter search terms" />
					</label>
					<label>
						Phone Number(s)*:
						<div className="phone-dropdown">
							<select value={selectedPhoneIndex} onChange={(e) => setSelectedPhoneIndex(Number(e.target.value))}>
								{formData.Phone &&
									formData.Phone.map((phone, index) => (
										<option key={index} value={index}>
											{phone || `Phone Number ${index + 1}`}
										</option>
									))}
							</select>
						</div>
						<div className="phone-editor">
							{formData.Phone && formData.Phone[selectedPhoneIndex] !== undefined ? (
								<input
									type="text"
									value={formData.Phone[selectedPhoneIndex]}
									onChange={(e) => handlePhoneChange(e.target.value)}
									placeholder="Edit selected phone number"
								/>
							) : (
								<p></p>
							)}
							<div className="button-group">
								<button type="button" id="blue" onClick={handleAddPhone}>
									Add New Phone Number
								</button>
								{formData.Phone && formData.Phone[selectedPhoneIndex] !== undefined && (
									<button type="button" id="red" onClick={handleDeletePhone}>
										Delete Selected Phone Number
									</button>
								)}
							</div>
						</div>
					</label>
					<label>
						Email(s)*:
						<div className="email-dropdown">
							<select value={selectedEmailIndex} onChange={(e) => setSelectedEmailIndex(Number(e.target.value))}>
								{formData.Email &&
									formData.Email.map((email, index) => (
										<option key={index} value={index}>
											{email || `Email ${index + 1}`}
										</option>
									))}
							</select>
						</div>
						<div className="email-editor">
							{formData.Email && formData.Email[selectedEmailIndex] !== undefined ? (
								<input
									type="text"
									value={formData.Email[selectedEmailIndex]}
									onChange={(e) => handleEmailChange(e.target.value)}
									placeholder="Edit selected email"
								/>
							) : (
								<p></p>
							)}
							<div className="button-group">
								<button type="button" id="blue" onClick={handleAddEmail}>
									Add New Email
								</button>
								{formData.Email && formData.Email[selectedEmailIndex] !== undefined && (
									<button type="button" id="red" onClick={handleDeleteEmail}>
										Delete Selected Email
									</button>
								)}
							</div>
						</div>
					</label>
					<label>
						Website:
						<textarea type="text" name="Website" value={formData.Website} onChange={handleChange} placeholder="Enter email address" />
					</label>
					<label>
						Address(es):
						<div className="address-dropdown">
							<select value={selectedAddressIndex} onChange={(e) => setSelectedAddressIndex(Number(e.target.value))}>
								{formData.Address &&
									formData.Address.map((address, index) => (
										<option key={index} value={index}>
											{address || `Address ${index + 1}`}
										</option>
									))}
							</select>
						</div>
						<div className="address-editor">
							{formData.Address && formData.Address[selectedAddressIndex] !== undefined ? (
								<input
									type="text"
									value={formData.Address[selectedAddressIndex]}
									onChange={(e) => handleAddressChange(e.target.value)}
									placeholder="Edit selected address"
								/>
							) : (
								<p></p>
							)}
							<div className="button-group">
								<button type="button" id="blue" onClick={handleAddAddress}>
									Add New Address
								</button>
								{formData.Address && formData.Address[selectedAddressIndex] !== undefined && (
									<button type="button" id="red" onClick={handleDeleteAddress}>
										Delete Selected Address
									</button>
								)}
							</div>
						</div>
					</label>
					<label>
						Rating:
						<textarea type="text" name="Rating" value={formData.Rating} onChange={handleChange} placeholder="Enter rating" />
					</label>
					<label>
						Admin Notes:
						<textarea type="text" name="adminNotes" value={formData.adminNotes} onChange={handleChange} placeholder="Enter admin notes" />
					</label>
					<button type="submit" id="blue">
						Save
					</button>
					{/* <button type="button" id="purple" onClick={openModal}>
						Autofill with AI
					</button> */}

					{isModalOpen && (
						<div className="ai-modal" onClick={(e) => e.stopPropagation()}>
							<div className="ai-modal-content">
								{console.log("Modal is open. Rendering AutofillAIForm...")}
								<AutofillAIForm
									onSubmitSuccess={(result) => {
										console.log("AutofillAIForm onSubmitSuccess triggered with result:", result);
										handleAutofill(result);
										closeModal(); // Close only on success
									}}
									onCancel={() => {
										console.log("AutofillAIForm onCancel triggered. Closing modal...");
										closeModal();
									}}
								/>
							</div>
						</div>
					)}

					<button type="button" id="red" onClick={onCancel}>
						Cancel
					</button>
				</div>
			</form>
		</div>
	);
};

export default EditEntryForm;
